module.exports = __webpack_public_path__ + "assets/media/hubspot-logo.78fb7bae.svg";